<template>
  <div :class="containerClass">
    <a @click="openWhatsAppModal" :class="linkClass" style="cursor: pointer;">
      <img src="/whatsapp.svg" width="30px" height="30px">
    </a>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import OffersHelper from '@/custom/classes/offers_helper'

export default {
  name: 'offer-whats-app-link',
  props: {
    payload: {
      type: Object,
      required: true
    },
    containerClass: {
      type: String,
      default: ''
    },
    linkClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      offers_helper: new OffersHelper()
    }
  },
  methods: {
    openWhatsAppModal () {
      this.create({
        designator: 'whatsapp-templates-modal',
        component_name: 'ModalOfferWhatsappTemplates',
        modal_title: 'הצעת משרה למועמד',
        modal_width: 900,
        is_center_modal: true,
        data: this.payload
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>
